export enum EdoChatType {
  CHAT = 'CHAT',

  GROUP = 'GROUP',
}
